import { FC, useCallback, useEffect, useState } from "react";
import HighCharts from "highcharts/highstock";
import HighchartsReact from "highcharts-react-official";

import {
  PIE_CHART_OPTIONS,
  PIE_CHART_OPTIONS_TSB,
} from "src/constants/highCharts";
import { wrapperFunctionPieChart } from "src/helpers";
import { pieChartObject } from "./types";



const CustomPieChart: FC<pieChartObject> = ({ pieChartObject, title }): JSX.Element => {
  const [data, setData] = useState({});


  const populatePieChart = useCallback(() => {    
    if (pieChartObject.length > 0) {
      const topPayorOptions = {
        ...PIE_CHART_OPTIONS,
        series: wrapperFunctionPieChart(pieChartObject)
      };
  
      const topPayorOptionsTSB = {
        ...PIE_CHART_OPTIONS_TSB,
        series: wrapperFunctionPieChart(pieChartObject)
      };
  
      setData(title === "Treatment Status Breakdown" ? topPayorOptionsTSB : topPayorOptions);
    } 
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pieChartObject]);

  useEffect(() => {
    populatePieChart();
  }, [populatePieChart]);
  
   
    

  

  return (
    <div>
      <div className="card mt-3">
        <div className="card-header bg-success-subtle">
          <h4 className="m-0 text-center text-black">{title}</h4>
        </div>

        <div className="card-body">
          {data && (data as any).series && <HighchartsReact highcharts={HighCharts} options={data} />}
        </div>
      </div>
    </div>
  );
};

export default CustomPieChart;
